import type { useSystemStore } from "./store";

type StoreActions = ReturnType<typeof useSystemStore.getState>;

type KeyTarget = { tagName?: string; isContentEditable?: boolean } | null;

function targetIsTextInput(target: KeyTarget): boolean {
  if (!target) return false;
  return (
    target.tagName === "INPUT" ||
    target.tagName === "TEXTAREA" ||
    target.isContentEditable === true
  );
}

/** True iff something was removed; callers gate `preventDefault()` on it. */
export function deleteSelectionForKey(
  key: string,
  target: KeyTarget,
  store: Pick<StoreActions, "selection" | "removeNodes" | "removeCables">,
): boolean {
  if (key !== "Delete" && key !== "Backspace") return false;
  if (targetIsTextInput(target)) return false;
  const { selection, removeNodes, removeCables } = store;
  if (selection.nodeIds.length === 0 && selection.cableIds.length === 0) return false;
  removeNodes(selection.nodeIds);
  removeCables(selection.cableIds);
  return true;
}

/** True iff at least one cable was reset; callers gate `preventDefault()` on it. */
export function resetSelectedCablesForKey(
  key: string,
  target: KeyTarget,
  store: Pick<StoreActions, "selection" | "resetCableLayouts">,
): boolean {
  if (key !== "r" && key !== "R") return false;
  if (targetIsTextInput(target)) return false;
  const { selection, resetCableLayouts } = store;
  if (selection.cableIds.length === 0) return false;
  resetCableLayouts(selection.cableIds);
  return true;
}
